export enum AbTestType {
  DRAFT = 'DRAFT',
  RUNNING = 'RUNNING',
  CONCLUDED = 'CONCLUDED',
}

export enum AbTestTabTypeLabel {
  DRAFTS = 'Drafts',
  RUNNING = 'Running',
  CONCLUDED_TESTS = 'Concluded tests',
}
export const tabMap: Record<string, string> = {
  drafts: AbTestTabTypeLabel.DRAFTS,
  running: AbTestTabTypeLabel.RUNNING,
  concluded: AbTestTabTypeLabel.CONCLUDED_TESTS,
};
export const reverseTabMap: Record<string, string> = {
  [AbTestTabTypeLabel.DRAFTS]: 'drafts',
  [AbTestTabTypeLabel.RUNNING]: 'running',
  [AbTestTabTypeLabel.CONCLUDED_TESTS]: 'concluded',
};
